import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
// import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
// const tag = '[SAGA_BLOG_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  /*---------- getHisobusBlogPage --------*/

  requestGetHisobusBlogPage: [],
  getHisobusBlogPageSuccess: ["getHisobusBlogPageResponse"],
  getHisobusBlogPageFailure: ["getHisobusBlogPageError"],

  /*---------- getHisobusBlogDetailPage --------*/

  requestGetHisobusBlogDetailPage: ["id"],
  getHisobusBlogDetailPageSuccess: ["getHisobusBlogDetailPageResponse"],
  getHisobusBlogDetailPageFailure: ["getHisobusBlogDetailPageError"]
}

const { Types, Creators } = createActions(functionDefinitions)

export const SagaBlogTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const SagBlogInitState = {
  blogDetail: []
}

export const INITIAL_STATE = Immutable(SagBlogInitState)

/* ------------- Reducers ------------- */

/*---------- getHisobusBlogPage --------*/

export const requestGetHisobusBlogPage = state => {
  return state.merge({
    getHisobusBlogPageFetching: true,
    getHisobusBlogPageResponse: null,
    getHisobusBlogPageError: null
  })
}
export const getHisobusBlogPageSuccess = (state, action) => {
  return state.merge({
    getHisobusBlogPageFetching: false,
    getHisobusBlogPageResponse: action.getHisobusBlogPageResponse,
    getHisobusBlogPageError: null
  })
}
export const getHisobusBlogPageFailure = (state, action) => {
  return state.merge({
    getHisobusBlogPageFetching: false,
    getHisobusBlogPageError: action.getHisobusBlogPageError
  })
}

/*---------- getHisobusBlogDetailPage --------*/

export const requestGetHisobusBlogDetailPage = (state, action) => {
  return state.merge({
    id: action.id,
    getHisobusBlogDetailPageFetching: true,
    getHisobusBlogDetailPageResponse: null,
    getHisobusBlogDetailPageError: null
  })
}
export const getHisobusBlogDetailPageSuccess = (state, action) => {
  return state.merge({
    getHisobusBlogDetailPageFetching: false,
    getHisobusBlogDetailPageResponse: action.getHisobusBlogDetailPageResponse,
    getHisobusBlogDetailPageError: null
  })
}
export const getHisobusBlogDetailPageFailure = (state, action) => {
  return state.merge({
    getHisobusBlogDetailPageFetching: false,
    getHisobusBlogDetailPageError: action.getHisobusBlogDetailPageError
  })
}
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- getHisobusBlogPage --------*/

  [Types.REQUEST_GET_HISOBUS_BLOG_PAGE]: requestGetHisobusBlogPage,
  [Types.GET_HISOBUS_BLOG_PAGE_SUCCESS]: getHisobusBlogPageSuccess,
  [Types.GET_HISOBUS_BLOG_PAGE_FAILURE]: getHisobusBlogPageFailure,

  /*---------- getHisobusBlogDetailPage --------*/

  [Types.REQUEST_GET_HISOBUS_BLOG_DETAIL_PAGE]: requestGetHisobusBlogDetailPage,
  [Types.GET_HISOBUS_BLOG_DETAIL_PAGE_SUCCESS]: getHisobusBlogDetailPageSuccess,
  [Types.GET_HISOBUS_BLOG_DETAIL_PAGE_FAILURE]: getHisobusBlogDetailPageFailure
})



// WEBPACK FOOTER //
// ./src/redux/sagaBlog/sagaBlogRedux.ts